// @flow
import React, { useContext, useState } from 'react';
import classnames from 'classnames';
import { isEmpty } from 'lodash';

import { COLORS } from 'Components/utils/color/colors';
import { getFromLocalStorage, setInLocalStorage } from 'Client/local-storage-api';
import { ICONS } from 'Components/utils/icon/icons';
import ResponsiveContext from 'Components/utils/responsive/responsiveContext';

import { Icon } from 'Components/frameworks/icon/Icon.jsx';
import { TextLink } from 'Components/frameworks/text-link/TextLink.jsx';

const CRISIS_ALERT_LOCALSTORAGE_KEY = 'dismissGlobalAlert';

type Props = {
  alertDate: string,
  className?: string,
  linkLabel: string,
  linkUrl: string,
};

export const CrisisAlertLinkBanner = (props: Props) => {
  const { isAppMounted } = useContext(ResponsiveContext);
  const [shouldDisplay, setShouldDisplay] = useState(true);

  if (!isAppMounted) {
    return null;
  }

  const { alertDate, className, linkLabel, linkUrl } = props;

  if (
    !shouldDisplay ||
    isEmpty(alertDate) ||
    isEmpty(linkLabel) ||
    getFromLocalStorage(CRISIS_ALERT_LOCALSTORAGE_KEY) === alertDate
  ) {
    return null;
  }

  return (
    <div
      className={classnames(
        className,
        'bg-white flex items-center max-w-full p-3 rtl:pr-8 relative rounded-small shadow',
      )}
    >
      <Icon
        className="flex-shrink-0"
        color={COLORS.ORANGE}
        name={ICONS.LIGHTBULB}
        isNotSquare
        width="1.875rem"
      />
      <TextLink
        className="underline rtl:ml-4"
        color={COLORS.GRAY_DARKER}
        iconRightName={null}
        label={linkLabel}
        url={linkUrl}
      />
      <button
        className="reset-button absolute leading-none p-2 top-0 rtl:right-0"
        onClick={() => {
          setInLocalStorage(CRISIS_ALERT_LOCALSTORAGE_KEY, alertDate);
          setShouldDisplay(false);
        }}
        type="button"
      >
        <Icon name={ICONS.CROSS} width="0.625rem" />
      </button>
    </div>
  );
};
